<script setup lang="ts">
import ScrollDown from './ScrollDown.vue'

const props = withDefaults(
  defineProps<{
    assetUrl?: string,
    align?: 'start' | 'center' | 'end'
    hasTitle?: boolean
    hasSubtitle?: boolean
    article?: boolean
    fitHeight?: boolean
    parallax?: boolean
    paddingTop?: number
    paddingBottom?: number
  }>(),
  { align: 'center', hasTitle: true, hasSubtitle: true, parallax: true, paddingTop: 4, paddingBottom: 4 }
)

const style = computed(() => {
  let styleList = [
    'background-color: #000000',
    `background-image: url('${props.assetUrl}')`,
    'background-size: cover',
    'background-position: center',
  ]

  if (props.fitHeight) {
    styleList.push('height: calc(100vh - 7rem)')
  }


  styleList.push(`padding-top: ${props.paddingTop * 4}px`)
  styleList.push(`padding-bottom: ${props.paddingBottom * 4}px`)

  return styleList.join('; ');
})
</script>

<template>
  <div class="relative flex justify-center items-center min-h-80 sm:min-h-96 w-full px-8" :style="style">
    <div class="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
    <div class="w-full flex flex-col gap-6 sm:gap-10 justify-center py-6 sm:py-12" :class="`items-${props.align}`">
      <div class="w-full mx-auto relative flex flex-col gap-4 justify-center" :class="{
        [`items-${props.align}`]: true,
        'xl:container': !props.article,
      }">
        <h1 v-if="hasTitle" class="text-3xl md:text-4xl lg:text-5xl text-center text-white font-bold">
          <slot name="title" />
        </h1>
        <h2 v-if="hasSubtitle" class="text-xl md:text-2xl lg:text-3xl text-center text-white font-normal">
          <slot name="subtitle" />
        </h2>
      </div>
      <ScrollDown v-if="props.fitHeight" />
      <slot name="content" />
    </div>
  </div>
</template>